/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoanDefaultCodes.module.css';
import { PatternFormat, NumericFormat } from 'react-number-format';

type patternProps = {
  label: string;
  formatStr: string;
  value: string | number;
  name: string;
  func?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const PatternInput = (props: patternProps) => {
  const { label, formatStr, value, name, func = null, disabled } = props;

  return (
    <tr>
      <th>{label + ':'}</th>
      <td>
        <PatternFormat
          format={formatStr}
          value={value}
          disabled={disabled}
          className={disabled ? Styles.disabled : ''}
          onChange={(e) => {
            if (func !== null) {
              func(e);
            }
          }}
        />
      </td>
    </tr>
  );
};

export default PatternInput;
